/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {ContactAddDto} from '../models/ContactAddDto'
import type {ContactDetailDtoListSuccessDataResult} from '../models/ContactDetailDtoListSuccessDataResult'
import type {ContactDetailDtoSuccessDataResult} from '../models/ContactDetailDtoSuccessDataResult'
import type {ContactEditDto} from '../models/ContactEditDto'

import type {CancelablePromise} from '../core/CancelablePromise'
import {OpenAPICouponCenter} from 'rest'
import {request as __request} from '../core/request'

export class ContactService {
  /**
   * @param requestBody
   * @returns ContactDetailDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static postApiContactAdd(
    requestBody?: ContactAddDto
  ): CancelablePromise<ContactDetailDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'POST',
      url: '/api/Contact/Add',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns ContactDetailDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static putApiContactEdit(
    requestBody?: ContactEditDto
  ): CancelablePromise<ContactDetailDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'PUT',
      url: '/api/Contact/Edit',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param contactId
   * @returns ContactDetailDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiContactGet(
    contactId?: number
  ): CancelablePromise<ContactDetailDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Contact/Get',
      query: {
        contactId: contactId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param merchantId
   * @returns ContactDetailDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiContactGetList(
    merchantId?: number
  ): CancelablePromise<ContactDetailDtoListSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Contact/GetList',
      query: {
        merchantId: merchantId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
